<template>
  <v-sheet height="100%" color="transparent">
    <v-container class="my-7" v-if="!loading">
      <section class="article mt-4">
        <div>
          <div class="d-flex justify-end">
            <share-buttons />
          </div>

          <div
            class="title-article mt-6 white--text"
            v-if="article.title"
            v-html="article.title"
          ></div>

          <div class="mt-6">
            <v-responsive :aspect-ratio="16 / 9" v-if="embedVideo">
              <iframe
                width="100%"
                height="100%"
                fill-height
                :src="embedVideo"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </v-responsive>
            <img
              v-else-if="article.img.featured"
              :src="this.files + article.img.featured + '?resize=1&w=750'"
              :alt="article.title"
              width="100%"
            />
          </div>

          <div
            class="text-article white--text mt-6"
            v-if="article.text"
            v-html="article.text"
          ></div>

          <div class="source-article white--text mt-2" v-if="article.author">
            <b>Autor:</b> {{ article.author }}
          </div>

          <div class="source-article white--text mt-2" v-if="article.source">
            <b>Fonte:</b> {{ article.source }}
          </div>
        </div>
      </section>
    </v-container>
    <v-sheet
      v-else
      class="d-flex justify-center align-center"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="white"
        indeterminate
      ></v-progress-circular>
    </v-sheet>
  </v-sheet>
</template>

<script>
import ShareButtons from "@/components/widgets/ShareButtons.vue";
import { getYoutubeCode } from "@/components/utils";

export default {
  data: () => ({
    loading: true,
    article: {},
  }),
  computed: {
    articleId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    embedVideo() {
      if (!this.$rest("articles").item.video) return "";
      return `https://www.youtube.com/embed/${getYoutubeCode(
        this.article.video
      )}`;
    },
  },
  methods: {
    get() {
      this.loading = true;
      this.data = {};

      var params = {};
      if (this.params) params = this.params;

      this.$rest("articles")
        .get({ id: this.articleId, params })
        .then((data) => {
          this.article = data;
          this.loading = false;
        })
        .catch(() => this.$router.replace("/error404"));
    },
  },
  watch: {
    articleId() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  components: {
    ShareButtons,
  },
};
</script>

<style scoped>
.category-article a {
  transition: all 0.1s linear;
}

.category-article a:hover {
  color: var(--v-primary-lighten2) !important;
}

.title-article {
  font-size: 32px !important;
  font-weight: 700;
}

.subtitle-article {
  font-size: 20px !important;
  font-weight: 700;
}

@media (max-width: 1199px) {
  .title-article {
    font-size: 26px !important;
  }
}

@media (max-width: 700px) {
  .title-article {
    font-size: 22px !important;
  }
}

.share-article {
  background-color: #3b5998;
  color: #ffffff;
  font-size: 14px;
}

.share-article .v-icon {
  font-size: 16px;
}

.share-article-item {
  letter-spacing: 0.2px;
}

.facebook-icon {
  color: #4267b2 !important;
}

.whatsapp-icon {
  color: #25d366 !important;
}

.twitter-icon {
  color: #1da1f2 !important;
}
</style>

<style>
.text-article img {
  margin: 20px 0 !important;
  width: 100%;
}

.text-article a * {
  color: var(--v-primary-base) !important;
}
</style>
